import { useNavigate, useLocation } from "react-router-dom";

// Scrolls to a homepage section when already on "/", otherwise navigates home
// with the hash so the section can be scrolled into view on load.
export function useSectionNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (hash) => {
    if (pathname === "/") {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    navigate("/" + hash);
  };
}
